<template>
  <div class="row">
    <div class="col">

      <!-- table -->
      <div class="card p-4">
        <vue-good-table v-if="logs.length"
          :columns="tableColumns"
          :rows="logs"
          :pagination-options="tablePagination"
          :search-options="{
            enabled: true,
            placeholder: 'Buscar..',
          }"
          styleClass="vgt-table"
        >
          <template slot="pagination-bottom">
            <table-pagination-component :_options="tablePaginationOptions" @paginate="pagination"></table-pagination-component>
          </template>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'total'">
              {{ props.row.activities_count || 0 }} atividades
            </span>
            <span v-if="props.column.field == 'actions'">
              <div>
                <a class="btn btn-sm btn-outline-secondary" :href="'/admin/log/generateactivity/'+props.row.id" title="Visualizar Atividades"><i class="far fa-eye"></i> Visualizar Atividades</a>
              </div>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
			  </vue-good-table>
        <div v-else class="text-center p-3 text-muted">
            <h5>Nenhum log encontrado!</h5>
        </div>
      </div>
      <!-- end table -->

      <div class="text-center p-4 text-muted" v-if="loading && logs.length == 0">
        <h5>Carregando...</h5>
        <p>Aguarde até que os dados sejam carregados...</p>
      </div>

      <!-- modal -->
			<div class="modal fade" id="modalActivities" tabindex="-1" aria-labelledby="modalActivitiesLabel" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered modal-lg">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="modalActivitiesLabel">Atividades Geradas</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<vue-good-table v-if="generatedActivities.length"
                :columns="tableColumnsActivities"
                :rows="generatedActivities"
                :pagination-options="tablePagination"
                :search-options="{
                  enabled: true,
                  placeholder: 'Buscar..',
                }"
                styleClass="vgt-table"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'actions'">
                    <div>
                      <a class="btn btn-sm btn-outline-secondary" title="Ver Atividade" :href="'/admin/activities/'+props.row.activity_id" target="_blank"><i class="far fa-eye"></i> Ver Atividade</a>
                    </div>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
                <template slot="pagination-bottom">
                  <table-pagination-component :_options="tablePaginationOptionsItems" @paginate="paginationItems"></table-pagination-component>
                </template>
              </vue-good-table>
              <div v-else class="text-center p-3 text-muted">
                  <h5>Nenhuma atividade gerada!</h5>
              </div>
						</div>
					</div>
				</div>
			</div>

    </div><!-- col -->
  </div><!-- row -->
</template>

<script>
  import configData from "../../config.js";
  export default {
    mixins: [configData],
    data() {
      return {
        logs: [],
        loading: false,
        generatedActivities: [],
        tablePagination: configData.tablePagination,
        tablePaginationOptions: {
          currentPage: 1,
          currentPerPage: 10,
          from: 0,
          to: 0,
          total: null
        },
        tableColumns: [
          {
            label: 'Data e Hora',
            field: 'created_at',
            type: 'date',
            dateInputFormat: "yyyy-MM-dd\'T\'HH:mm:ss.SSSSSSXXX",
            dateOutputFormat: 'dd/MM/yyyy HH:mm:ss'
          },{
            label: "Total de Atividades",
            field: "total"
          },{
            label: "Ações",
            field: "actions",
            width: "220px"
          }
        ],
        tableColumnsActivities: [
          {
            label: 'ID',
            field: 'activity_id',
            width: "100px"
          },{
            label: "Título",
            field: "info.title"
          },{
            label: "Ações",
            field: "actions",
            width: "140px"
          }
        ]
        ,
        tablePaginationOptionsItems: {
          currentPage: 1,
          currentPerPage: 10,
          from: 0,
          to: 0,
          total: null
        },
        selectedLog: {
          id: null
        }
      }
    },
    mounted() {
      this.loadLogs();
    },
    methods: {
      pagination(page){
        this.tablePaginationOptions = {
          currentPage: page.options.currentPage,
          currentPerPage: page.options.currentPerPage,
          from: page.options.from,
          to: page.options.to,
          total: page.options.total
        };
        this.loadLogs();
      },
      loadLogs() {
        let _this = this;
        _this.loading = true;
        _this.logs = [];
        var params = {
          page: _this.tablePaginationOptions.currentPage,
          perPage: _this.tablePaginationOptions.currentPerPage,
        };
        axios.post('/admin/log/generateactivity/filter', {}, { params: params }).then((res) => {
          const { data, total, from, to } = res.data.data;
          _this.tablePaginationOptions.total = total;
          _this.tablePaginationOptions.from = from;
          _this.tablePaginationOptions.to = to;
          _this.logs = [...data];
          _this.loading = false;
        }).catch((err) => {
          _this.loading = false;
        });
      },
      viewLogActivities(log){
        // redirect to the detail page
        window.location.href = '/admin/log/generateactivity/'+log.id;
      },
      paginationItems(page){
        this.tablePaginationOptionsItems = {
          currentPage: page.options.currentPage,
          currentPerPage: page.options.currentPerPage,
          from: page.options.from,
          to: page.options.to,
          total: page.options.total
        };
        this.loadGeneratedActivities();
      },
      loadGeneratedActivities(modal = false){
        if(this.selectedLog && this.selectedLog.id != null){
          let _this = this;
          _this.loading = true;
          _this.generatedActivities = [];
          var params = {
            page: _this.tablePaginationOptionsItems.currentPage,
            perPage: _this.tablePaginationOptionsItems.currentPerPage,
          };
          axios.post('/admin/log/generateactivity/items', { log: _this.selectedLog.id }, { params: params }).then((res) => {
            const { data, total, from, to } = res.data.data;
            _this.tablePaginationOptionsItems.total = total;
            _this.tablePaginationOptionsItems.from = from;
            _this.tablePaginationOptionsItems.to = to;
            _this.generatedActivities = [...data];
            _this.loading = false;

            if(modal){
              $("#modalActivities").modal('show');
            }

          }).catch((err) => {
            _this.loading = false;
          });
        }
      }
    }
  }
</script>
